import { cx } from '~/common/utils';

export type Theme = 'primary' | 'secondary';

export const getItemClassName = (theme?: Theme) =>
  cx(
    theme === 'primary' ? 'hover:text-text-100 text-text-100' : 'hover:text-text-500 text-text-500',
    'flex items-center font-brand-b2 cursor-pointer w-full whitespace-nowrap',
  );
